<template>
  <div class="h-100 d-flex align-center justify-center">
    <!-- 👉 Footer: content -->
    <span class="d-flex align-center text-medium-emphasis">
      &copy;
      {{ new Date().getFullYear() }}
      Godana Service - All Rights Reserved
    </span>
  </div>
</template>
